<template>
  <div>
    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-400 mb-8">
      <h1 class="text-4xl">
        TERMS & CONDITIONS
      </h1>
    </div>
    <div class="mb-8 p-2 w-full flex flex-wrap bg-grey-light" v-if="ready">
      <div class="flex flex-wrap">
        <div class="flex w-full flex-wrap mb-3">
          <div class="w-full flex flex-wrap justify-center">
            <div class="flex items-center">
              <div class="ql-snow">
                <div class="ql-editor" style="white-space: normal;">
                  <div class="mb-4" v-html="pages.content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <LoadersSpinner/>
    </div>
  </div>
</template>
<script setup>
import {ref} from 'vue';
import {http} from "~/utils/http";
import {Page} from "~/composables/nhTypes"

const pages = ref(new Page);
const ready = ref(false);

const getPages = async () => {
  ready.value = false;
  try {
    await http
        .get("/api/pages/" + 28)
        .then((response) => {
          pages.value = response.data.page;
          ready.value = true;
        });
  } catch (e) {
    ready.value = true;
    console.log(e.response.data.error);
  }
};

getPages()
</script>
